exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tableHistory > thead > tr {\n  background: #1c869a;\n  color: white;\n}\n", ""]);

// exports
